import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import { ClientModel } from "..";

var AbstractCategory = /*#__PURE__*/function (_ClientModel) {
  _inherits(AbstractCategory, _ClientModel);

  var _super = _createSuper(AbstractCategory);

  function AbstractCategory() {
    _classCallCheck(this, AbstractCategory);

    return _super.apply(this, arguments);
  }

  _createClass(AbstractCategory, [{
    key: "transformDataForPersist",
    value: function transformDataForPersist() {
      var data = _objectSpread({}, _get(_getPrototypeOf(AbstractCategory.prototype), "transformDataForPersist", this).call(this));

      delete data._links;
      delete data.link;
      return data;
    }
  }, {
    key: "transformDataForPatch",
    value: function transformDataForPatch() {
      return this.transformDataForPersist();
    }
  }]);

  return AbstractCategory;
}(ClientModel);

export { AbstractCategory };